import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

import { GroupDefaultInteractionRulesModule } from '@main-client/src/app/group-custom-segments-settings/group-default-interaction-rules/group-default-interaction-rules.module';
import { GroupSegmentInputFormModule } from '@main-client/src/app/group-custom-segments-settings/group-segment-input-form/group-segment-input-form.module';

import { GroupCustomPrivateSegmentsDrawerService } from './group-custom-private-segments-drawer.service';

import { GroupCustomPrivateSegmentsDrawerComponent } from './group-custom-private-segments-drawer.component';

@NgModule({
  declarations: [GroupCustomPrivateSegmentsDrawerComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    GroupDefaultInteractionRulesModule,
    GroupSegmentInputFormModule,
    MatButtonModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    NzDrawerModule,
    ReactiveFormsModule,
  ],
  providers: [GroupCustomPrivateSegmentsDrawerService],
})
export class GroupCustomPrivateSegmentsDrawerModule {}
